import React from "react";
import { useSettings } from "hooks/useStore";

const Overlay = ({ show }) => {
	const { isMenuOpen, isCartOpen, isSearchOpen, toggleSearch } =
		useSettings(["isMenuOpen", "isCartOpen", "isSearchOpen", "toggleSearch"]);

	return (isMenuOpen || isCartOpen || isSearchOpen || show) &&
		<div className="overlay animate-fadeIn" onClick={() => toggleSearch(false)} data-type="overlay" />;
};

export default Overlay;
